import Swiper, {Autoplay} from 'swiper';

export class BindIdCardsComponent {
  config = {
    slidesPerView: 'auto',
    spaceBetween: 14,
    autoplay: {
      delay: 5000
    }
  };

  assetsUrl = typeof assets_url === 'undefined' ? '' : assets_url;

  container = document.querySelector('.animated-boxes_separate-cards');

  swiper = null;

  constructor() {
    if (!this.container) {
      return;
    }

    this.initialize();

    this.addEventListeners();
  }

  initialize() {
    Swiper.use([Autoplay]);

    if (window.outerWidth <= 768) {
      this.createSlider();
    }
  }

  addEventListeners() {
    window.addEventListener('resize', (e) => this.windowResizeHandler(e));
  }

  windowResizeHandler(e) {
    window.outerWidth > 768
      ? this.destroySlider()
      : this.createSlider();
  }

  createSlider() {
    if (this.swiper) {
      return;
    }

    const container = this.container;
    if (!container) {
      return;
    }

    container.classList.add('swiper-container');

    const wrapper = container.querySelector('.elementor-container');
    if (!wrapper) {
      return;
    }

    wrapper.classList.add('swiper-wrapper');

    const items = wrapper.getElementsByClassName('animated-boxes__item');
    if (items.length) {
      Array.from(items).forEach((item) => {
        item.classList.add('swiper-slide');
      });
    }

    const swiper = new Swiper(container, this.config);
    container.appendChild(this.getNav());

    this.swiper = swiper;
  }

  destroySlider() {
    const swiper = this.swiper;
    if (!swiper) {
      return;
    }

    const container = this.container;
    if (!container) {
      return;
    }

    container.classList.remove('swiper-container');

    const wrapper = container.querySelector('.elementor-container');
    if (!wrapper) {
      return;
    }

    wrapper.classList.remove('swiper-wrapper');

    const items = wrapper.getElementsByClassName('animated-boxes__item');
    if (items.length) {
      Array.from(items).forEach((item) => {
        item.classList.remove('swiper-slide');
      });
    }

    const nav = this.container.querySelector('.navigation');
    if (nav) {
      nav.remove();
    }

    swiper.destroy();
    this.swiper = null;
  }

  getNav() {
    const nav = document.createElement('div');
    nav.classList.add('navigation');

    const arrow = document.createElement('a');
    arrow.classList.add('arrow');

    const arrowPrev = arrow.cloneNode(true);
    arrowPrev.classList.add('arrow-prev');
    const imgPrev = document.createElement('img');
    imgPrev.src = `${this.assetsUrl}/images/arrow-prev.svg`;
    arrowPrev.appendChild(imgPrev);
    arrowPrev.addEventListener('click', (e) => this.arrowPrevClickHandler(e));

    const arrowNext = arrow.cloneNode(true);
    arrowNext.classList.add('arrow-next');
    const imgNext = document.createElement('img');
    imgNext.src = `${this.assetsUrl}/images/arrow-next.svg`;
    arrowNext.appendChild(imgNext);
    arrowNext.addEventListener('click', (e) => this.arrowNextClickHandler(e));

    nav.appendChild(arrowPrev);
    nav.appendChild(arrowNext);

    return nav;
  }

  arrowPrevClickHandler(e) {
    this.swiper.slidePrev();
  }

  arrowNextClickHandler(e) {
    this.swiper.slideNext();
  }
}